import React from 'react';
import { motion } from 'framer-motion';
import { FaCheckCircle } from 'react-icons/fa';
import './About.css';

const About = () => {
  const highlights = [
    'Quality-first approach to software development',
    'User-centric testing methodologies',
    'Shift-left testing strategy implementation',
    'Comprehensive test coverage across all layers'
  ];

  const expertise = [
    { icon: '🌐', title: 'Web Applications', desc: 'Cross-browser testing, responsive design validation' },
    { icon: '📱', title: 'Mobile Applications', desc: 'iOS & Android app testing, device compatibility' },
    { icon: '🔌', title: 'APIs', desc: 'REST API testing, endpoint validation, integration testing' },
    { icon: '⚙️', title: 'Admin Dashboards', desc: 'Complex UI testing, data validation, workflow testing' }
  ];

  return (
    <section id="about" className="about">
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <h2 className="section-title">About Me</h2>
          <p className="section-subtitle">
            Dedicated QA Engineer with expertise in manual and automation testing
          </p>
        </motion.div>

        <div className="about-content">
          <motion.div
            className="about-text"
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <p className="about-description">
              As a Software Quality Assurance Engineer, I specialize in ensuring software excellence through 
              comprehensive testing strategies, automation frameworks, and performance validation. My approach 
              combines technical expertise with a deep understanding of user needs to deliver high-quality, 
              reliable software solutions.
            </p>

            <p className="about-description">
              With hands-on experience in both manual and automated testing, I excel at identifying critical 
              issues early in the development cycle, implementing robust test frameworks, and collaborating 
              with cross-functional teams to maintain the highest quality standards.
            </p>

            <div className="about-highlights">
              <h3>QA Mindset & Approach</h3>
              <ul className="highlights-list">
                {highlights.map((highlight, index) => (
                  <motion.li
                    key={index}
                    initial={{ opacity: 0, x: -20 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true }}
                    transition={{ delay: 0.3 + index * 0.1 }}
                  >
                    <FaCheckCircle className="check-icon" />
                    <span>{highlight}</span>
                  </motion.li>
                ))}
              </ul>
            </div>
          </motion.div>

          <motion.div
            className="about-expertise"
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <h3>Experience With</h3>
            <div className="expertise-grid">
              {expertise.map((item, index) => (
                <motion.div
                  key={index}
                  className="expertise-card"
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: 0.4 + index * 0.1 }}
                  whileHover={{ y: -5 }}
                >
                  <div className="expertise-icon">{item.icon}</div>
                  <h4>{item.title}</h4>
                  <p>{item.desc}</p>
                </motion.div>
              ))}
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default About;
